import { create } from 'zustand';
import type { SignupFormData, OptionalProfileData } from '../types/onboarding';

/**
 * Onboarding Store
 * Temporary storage for onboarding data to track profile completion
 * Data is cleared after user reaches dashboard
 */

interface OnboardingState {
    // State
    signupData: SignupFormData | null;
    optionalProfileData: OptionalProfileData | null;

    // Actions
    setSignupData: (data: SignupFormData) => void;
    setOptionalProfileData: (data: OptionalProfileData) => void;
    clearOnboardingData: () => void;
}

export const useOnboardingStore = create<OnboardingState>()((set) => ({
    // Initial state
    signupData: null,
    optionalProfileData: null,

    // Actions
    setSignupData: (data: SignupFormData) => {
        set({ signupData: data });
    },

    setOptionalProfileData: (data: OptionalProfileData) => {
        set({ optionalProfileData: data });
    },

    clearOnboardingData: () => {
        set({
            signupData: null,
            optionalProfileData: null,
        });
    },
}));
